import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Layout from "../pages/Layout/Layout";
import SuccessPage from "../Components/SuccessPage/SuccessPage";
import Checkout from "../Components/Checkout/Checkout";
import DashboardLayout from "../pages/DashboardLayout/DashboardLayout";
import Dashboard from "../pages/InitialCompanySetup/Dashboard";
import DashboardIncorporation from "../pages/DashboardLayout/DashboardIncorporation";
import LoginPage from "../pages/login/Login";
import RedirectToSetup from "../pages/InitialCompanySetup/RedirectToSetup";
import AccountingPage from "../pages/AccountingPage/AccountingPage";
import AdvisoryPage from "../pages/AdvisoryPage/AdvisoryPage";
import LegalSupportPage from "../pages/LegalSupportPage/LegalSupportPage";
import SoftwarePage from "../pages/SoftwarePage/SoftwarePage";
import DashboardProgressChecklist from "../pages/Dashboard/Dashboard";
import ForgotPassword from "../pages/ForgotPassword/ForgotPassword";
import ResetPassword from "../pages/ForgotPassword/ResetPassword";
import PaymentSuccessPage from "../Components/SuccessPage/PaymentSuccessPage";
import PaymentFailedPage from "../Components/SuccessPage/PaymentFailedPage";
import CompanySetupLayout from "../pages/DashboardLayout/CompanySetupLayout";
import OnboardingPage from "../pages/OnboardingPage/OnboardingPage";
import Onboarding from "../pages/Onboarding";

import InformationPage from "../pages/admin/Information/InformationPage";
import Deadlines from "../pages/Deadline";
function Router() {
	return (
		<BrowserRouter>
			<Routes>
				<Route path='/' element={<RedirectToSetup />} />
				<Route path='/setup' element={<Layout />}>
					<Route path='' element={<Dashboard />} />
				</Route>
				<Route path='/success' element={<SuccessPage />} />
				<Route
					path='/payment-success'
					element={<PaymentSuccessPage />}
				/>
				<Route path='/payment-failed' element={<PaymentFailedPage />} />
				<Route path='/checkout' element={<Checkout />} />
				<Route path='/login' element={<Layout />}>
					<Route path='' element={<LoginPage />} />
				</Route>
				<Route path='/forgot-password' element={<ForgotPassword />} />
				<Route path='/reset-password' element={<ResetPassword />} />

				<Route path='/onboarding' element={<Onboarding />} />
				<Route path='/onboarding/:id' element={<OnboardingPage />} />

				<Route path='/dashboard' element={<DashboardLayout />}>
					<Route index element={<DashboardProgressChecklist />} />
				</Route>
				<Route path='/company' element={<DashboardLayout />}>
					<Route index element={<DashboardIncorporation />} />
					<Route path='accounting' element={<AccountingPage />} />
					<Route path='advisory' element={<AdvisoryPage />} />
					<Route path='legalSupport' element={<LegalSupportPage />} />
					<Route path='software' element={<SoftwarePage />} />
					<Route path='documents' element={<InformationPage />} />
					<Route path='deadlines' element={<Deadlines />} />
				</Route>
				<Route path='/get-started' element={<DashboardLayout />}>
					<Route index element={<DashboardProgressChecklist />} />
					<Route index element={<CompanySetupLayout />} />
				</Route>
			</Routes>
		</BrowserRouter>
	);
}

export default Router;
